import "./standardMaterial.decalMap.js";
import "./PBR/pbrMaterial.decalMap.js";
import "../Meshes/abstractMesh.decalMap.js";
